import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API}/api`,
  validateStatus: (status) => status >= 200 && status < 500,
});

export default API;
